var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item is-desktop-icon-only",attrs:{"title":"Conectare"},on:{"click":_vm.login}},[_vm._v(" Conectare ")])}
var staticRenderFns = []

export { render, staticRenderFns }